module.exports = __webpack_public_path__ + "static/media/icon_menu_active.1af6a0a7.svg";